import BaseModel from '@/lib/models/base-model';
import defineProperty from '@/lib/helpers/define-property';
import modelsStore from '@/lib/services/models-store';
import store from '@/store';

import {
  INIT_VALIDATION,
} from '@/lib/constants/mutations';

import {
  VALIDATION_TYPE,
} from '@/lib/constants/model-types';

import {
  INVALID,
  VALID,
  UNPROCESSED,
} from '@/lib/constants/validations';

class ValidationModel extends BaseModel {
  constructor({
    name,
    errorMessage,
    condition,
    extractValueFn,
    attachField,
  }, optionsArg) {
    super();

    const defaultArgs = { addFirst: false };
    const options = Object.assign({}, optionsArg, defaultArgs);

    defineProperty(this, 'name');
    this.name = `${attachField.name}__${name}`;

    defineProperty(this, 'errorMessage');
    this.errorMessage = errorMessage;

    // TODO: Check if this should be move to a more stateless class
    this.__extractValueFn = extractValueFn;
    this.__condition = condition;

    attachField.addValidation(this, options.addFirst);

    store.commit(INIT_VALIDATION, {
      name: this.name,
    });
  }

  get $state() {
    return store.state.formData.validationStates[this.name];
  }

  get isUnprocessed() {
    return this.$state.validity === UNPROCESSED;
  }

  get isInvalid() {
    return this.$state.validity === INVALID;
  }

  get isValid() {
    return this.$state.validity === VALID;
  }

  static get $modelType() {
    return VALIDATION_TYPE;
  }

  triggerValidation(values) {
    const valueToValidate = this.__extractValueFn(values);
    const outputValidation = this.__condition(valueToValidate);

    const validationState = outputValidation ? VALID : INVALID;

    return {
      name: this.name,
      newValidity: validationState,
    };
  }

  resetValidation() {
    return {
      name: this.name,
      newValidity: UNPROCESSED,
    };
  }
}

modelsStore.registerClass(ValidationModel);

export default ValidationModel;
